import css from './css.gif';
import adobe from './adobe_getflash4.gif';
import enchantedForest from './gc_enchantedforest.gif';
import gotHTML from './got_html.gif';
import homer from './homernow.gif';
import imaginaryLand from './imaginaryland2.gif';
import spongebobWebsite from './thespongebobwebsite.gif';
import noweb3 from './noweb3.gif';
import sharingiscaring from './sharingiscaring.gif';
import yesterweb from './yesterweb.png';
import forever from './4ever.gif';
import eightyeight from './88x31.gif';
import eyes from './besteyes3.gif';
import win98 from './win98.gif';

export const littleGuys = [
    {
        asset: css,
        source: "https://cyber.dabamos.de/88x31/",
        alt: "made with cascading style sheets"
    },
    {
        asset: adobe,
        source: "https://cyber.dabamos.de/88x31/",
        alt: "get Adobe Flash Player"
    },
    {
        asset: enchantedForest,
        source: "https://cyber.dabamos.de/88x31/",
        alt: "GeoCities Enchanted Forest"
    },
    {
        asset: gotHTML,
        source: "https://cyber.dabamos.de/88x31/",
        alt: "got HTML?"
    },
    {
        asset: homer,
        source: "https://cyber.dabamos.de/88x31/",
        alt: "Homer Now!"
    },
    {
        asset: imaginaryLand,
        source: "https://cyber.dabamos.de/88x31/",
        alt: "imaginary land rainbow text"
    },
    {
        asset: spongebobWebsite,
        source: "https://web.archive.org/web/20090829094741/http://geocities.com/spongebobsquarepants_is_cool/linkme.html",
        alt: "The Spongebob Website"
    },
    {
        asset: noweb3,
        source: "https://yesterweb.org/no-to-web3/",
        alt: "keep the web free; say no to web 3"
    },
    {
        asset: sharingiscaring,
        source: "https://creativecommons.org/about/",
        alt: "sharing is caring"
    },
    {
        asset: yesterweb,
        source: "https://yesterweb.org/",
        alt: "yesterweb; reclaim the net"
    },
    {
        asset: forever,
        source: "https://cyber.dabamos.de/88x31/",
        alt: ""
    },
    {
        asset: eightyeight,
        source: "https://cyber.dabamos.de/88x31/",
        alt: "88x31"
    },
    {
        asset: eyes,
        source: "https://cyber.dabamos.de/88x31/",
        alt: "best viewed with eyes"
    },
    {
        asset: win98,
        source: "http://www.88x31.nl/index7.html",
        alt: "Made with Microsoft Windows 98"
    }
]